import { render } from "./SearchResults.vue?vue&type=template&id=506a80f8&scoped=true"
import script from "./SearchResults.vue?vue&type=script&lang=js"
export * from "./SearchResults.vue?vue&type=script&lang=js"

import "./SearchResults.vue?vue&type=style&index=0&id=506a80f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-506a80f8"

export default script